/* TODO: t() */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import FormElementBase from '../FormElementBase';
import FieldEditor from './MultichoiceElement/MultichoiceElementFieldEditorView';
import FormView from './MultichoiceElement/MultichoiceElementFormView';
import EditView from './MultichoiceElement/MultichoiceElementEditView';
import { Icon } from '../../uiold';

import IndexedList from '../../../support/shared/IndexedList';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';
import { OptionValue } from '../../../types/FormBuilder/FormElements';
import { Market } from '../../../types/shared/Market';
import { Field } from '../../../types/shared/Vendor';
import { toMap } from '../../../support/helpers/toMap';
import { getOptionsFromDefinition } from '../../../support/helpers/CategoryOptions';
import { MultichoiceElementDefinition } from '../../../runtypes/SignupFormDefinitionRuntype';

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: Array<string> | null | undefined;
  // onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type FormViewProps = {
  onChange?: (id: string, value: Array<string>) => void;
};

type EditViewProps = {
  value: Array<string>;
  onChange: (id: string, value: Array<string>) => void;
};

class MultichoiceElement extends FormElementBase {
  static getType() {
    return 'MultichoiceElement';
  }

  static getDescription() {
    return 'Multiple Choice';
  }

  static getAttributes() {
    const newMultipleChoice: Omit<
      MultichoiceElementDefinition,
      'type' | 'id'
    > = {
      name: 'Multiple Choice',
      label: 'Multiple Choice',
      options: [
        { id: '1', name: 'One' },
        { id: '2', name: 'Two' },
        { id: '3', name: 'Three' },
      ],
      // Allow multiple answers (e.g. checkboxes).
      allow_multi: false,
      disable_select_all: false,
      // Condense the options into a popover/dropdown.
      condensed: false,
      hidden: false,
      is_required: false,
      is_public: false,
    };
    return newMultipleChoice;
  }

  static getIconName() {
    return 'multipleChoice';
  }

  static getIcon() {
    return <Icon name="multipleChoice" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        readOnly={true}
      />
    );
  }

  renderFormView(props?: FormViewProps) {
    props = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { value } = props;
    const options = getOptionsFromDefinition(this.definition);
    const optionsMap = toMap(options);
    return (
      <span>
        {Array.isArray(value)
          ? value.map((id) => optionsMap.get(id)?.name ?? '').join(', ')
          : ''}
      </span>
    );
  }

  renderEditView(props: EditViewProps) {
    let { value } = props;
    // Ensure we don't pass `null` for value (actually, undefined would be fine).
    if (value == null) {
      props = { ...props, value: [] };
    }
    return (
      <EditView key={this.id} definition={this.definition as any} {...props} />
    );
  }

  getValueAsOptions(): Array<OptionValue> {
    let { options } = this.definition;
    if (!Array.isArray(options)) {
      return [];
    }
    return options;
  }
}

export default MultichoiceElement;
